import Vue from 'vue';
import Vuex from 'vuex';
import router, { slides } from '@/router/index';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    lastSlide: '/',
    isBackMove: false,
    orientation: 'landscape',
    progress: 0,
    progressCount: slides.length - 2,
    reviews: [],
    // isHintsActive: true,
    // resultsSlide: 0,
  },
  getters: {
    isPortrait({ orientation }) {
      return orientation === 'portrait';
    },
    // progress() {
    //   const { current } = router.history || {};
    //   const currentIndex = slides.findIndex((slide) => slide.path === current.path);
    //   return Math.round(100 / slides.length) * (currentIndex + 1);
    //   // console.log('router', router);
    // },
  },
  mutations: {
    setOrientation(state, orientation) {
      state.orientation = orientation;
    },
    setLastSlide(state, slide) {
      state.lastSlide = slide;
    },
    setMoveFlag(state, flag) {
      state.isBackMove = flag;
    },
    setProgress(state, index) {
      const { progressCount } = state;
      state.progress = index >= progressCount - 1 ? 100 : Math.round(100 / progressCount) * (index + 1);
    },
    setReviews(state, reviews) {
      state.reviews = reviews;
    },
    // setHintsFlag(state, flag) {
    //   state.isHintsActive = flag;
    // },
    // setResultsSlide(state, index) {
    //   state.resultsSlide = index;
    // },
  },
  actions: {
    fetchReviews({ commit }) {
      return Promise.resolve().then(() => {
        commit('setReviews', [
          {
            name: 'Денис Абрамов',
            company: 'ПАО «Норникель»',
            text: 'Наша компания применяла схожие принципы, описанные сотрудниками в ролике «Газпромбанка»\nТак же хотелось бы отметить, что эти принципы отлично работают в тех ситуациях, когда общая работоспособность сотрудников...\nТак же хотелось бы отметить, что эти принципы отлично работают в тех ситуациях, когда общая работоспособность сотрудников...',
          },
          {
            name: 'Ольга Романова',
            company: 'АО «Газпромбанк»',
            text: 'Так же хотелось бы отметить, что эти принципы отлично работают в тех ситуациях, когда общая работоспособность сотрудников...',
          },
          {
            name: 'Денис Абрамов',
            company: 'ПАО «Норникель»',
            text: 'Наша компания применяла схожие принципы, описанные сотрудниками в ролике «Газпромбанка»\nТак же хотелось бы отметить, что эти принципы отлично работают в тех ситуациях, когда общая работоспособность сотрудников...',
          },
          {
            name: 'Денис Абрамов',
            company: 'ПАО «Норникель»',
            text: 'Наша компания применяла схожие принципы, описанные сотрудниками в ролике «Газпромбанка»',
          },
        ]);
      });
    },
    // restart() {
    //   store.replaceState(initState);
    //   router.push(initState.lastSlide);
    // },
  },
});

router.beforeEach((to, from, next) => {
  const fromIndex = slides.findIndex((slide) => slide.path === from.path);
  const toIndex = slides.findIndex((slide) => slide.path === to.path);
  store.commit('setMoveFlag', fromIndex > toIndex);
  store.commit('setLastSlide', to.path);
  store.commit('setProgress', toIndex);
  next();
});

export default store;
